import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M16.62 2.55a4.71 4.71 0 0 0-6.661 0c-.415.415-.731.89-.959 1.396a4.672 4.672 0 0 0-.96-1.396 4.71 4.71 0 0 0-6.661 6.66L9 16.829l7.62-7.62a4.707 4.707 0 0 0 0-6.659zm-8.254 8.928L5.372 8.484l1.061-1.061 1.934 1.934 4.146-4.146 1.061 1.061-5.208 5.206z" />
  </svg>
);

export default SvgComponent;
